
import { defineComponent, PropType } from "vue";
import { Campaign } from "@/models/campaign";

export default defineComponent({
    name: 'FooterComponent',
    props: {
        campaign: { type: Object as PropType<Campaign>, required: true },
        showBackgroundImage: Boolean,
    },
    computed: {
        getTermsUrl() {
            if (this.campaign.termsURL) {
                return this.campaign.termsURL;
            }
            return `${this.campaign.contributionURL}?legal=terms`;
        },

        getPrivacyUrl() {
            if (this.campaign.privacyURL) {
                return this.campaign.privacyURL;
            }
            return `${this.campaign.contributionURL}?legal=privacy`;
        },
        showDeezerLogo() {
            const DEEZER_PROFILES_ID = ['f1f96e1f-f2c0-4a00-916b-002f4daf5ff6', 'd51d03a8-207d-45f3-af50-7c2516c87a40', '092df3fa-1200-487b-877d-446bf40e5cb4', 'd37531a0-b836-4079-82d7-8bc405e6ef23'];
            if(this.campaign.profile.id && DEEZER_PROFILES_ID.includes(this.campaign.profile.id)) {
                return true;
            } else {
                return false;
            }
        }
    },
});
